import { useEffect, useState } from "react";
import { getAllManufacturer } from "../services/dashboard";

export const useAllManufacturer = () => {
  const [manufacturer, setManufacturer] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchManufacturer();
  }, []);

  const fetchManufacturer = async () => {
    setLoading(true);
    try {
      const res = await getAllManufacturer();
      setManufacturer(res.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return { manufacturer, loading };
};
